import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { BabylonActions, ReactBabylonLink } from '../../../babylon';
import * as log from '../../../utils/log';
import * as Wallet from '../../../wallet/api';
export const getJockeys = createAsyncThunk('jockeys/pages', async ({ walletId }) => {
    try {
        return (await Wallet.getJockeys(walletId)).sort((a, b) => {
            const c = a.personality + a.displayName;
            const d = b.personality + b.displayName;
            return c < d ? -1 : c === d ? 0 : 1;
        });
    }
    catch (err) {
        return err.response;
    }
});
export const getJockey = createAsyncThunk('jockey/id', async (asset) => {
    try {
        return await Wallet.getJockey(asset);
    }
    catch (err) {
        return err.response;
    }
});
export const initialState = {
    error: null,
    jockeys: null,
    filteredJockeys: null,
    jockey: null,
    pending: false
};
export const jockeys = createSlice({
    name: 'jockeys',
    initialState,
    reducers: {
        resetJockey: (state) => {
            state.jockey = null;
        },
        saveFilteredJockeys: (state, action) => {
            var _a, _b, _c;
            const assetNames = action.payload.map((jockey) => jockey.displayName).sort();
            const prevNames = (_b = (_a = state.filteredJockeys) === null || _a === void 0 ? void 0 : _a.map((jockey) => jockey.displayName).sort()) !== null && _b !== void 0 ? _b : [];
            log.debug(assetNames);
            log.debug(prevNames);
            let reload = assetNames.length !== prevNames.length;
            if (!reload) {
                reload = prevNames === null || prevNames === void 0 ? void 0 : prevNames.reduce((reload, jockey, i) => {
                    const name = assetNames.length > i ? assetNames[i] : null;
                    return reload || jockey !== name;
                }, false);
            }
            if (reload === true) {
                state.filteredJockeys = action.payload;
                log.warn('Jockeys filter changed: refreshing the 3d scene');
                (_c = ReactBabylonLink.StateBus.get('isScreenLocked')) === null || _c === void 0 ? void 0 : _c.set(true);
                BabylonActions.RefreshScene();
            }
            else {
                log.debug('Jockeys filter did not change');
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getJockeys.fulfilled, (state, action) => {
            state.pending = false;
            state.jockeys = action.payload;
            state.filteredJockeys = action.payload ? [...action.payload] : null;
            log.debug(`Resetting the list of filtered jockeys : ${action.payload.length}`);
        });
        builder.addCase(getJockeys.rejected, (state) => {
            state.pending = false;
        });
        builder.addCase(getJockeys.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(getJockey.fulfilled, (state, action) => {
            state.pending = false;
            state.jockey = action.payload;
        });
    }
});
export const { resetJockey, saveFilteredJockeys } = jockeys.actions;
export default jockeys.reducer;
